import { supabase } from './supabase';

// Generate a secure state parameter
const generateState = (): string => {
  const stateArray = new Uint8Array(32);
  crypto.getRandomValues(stateArray);
  return Array.from(stateArray, byte => 
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~'[byte % 66]
  ).join('');
};

export const startFacebookOAuth = async () => {
  try {
    // Get current user ID
    const { data: { user } } = await supabase.auth.getUser();
    if (!user?.id) {
      throw new Error('Not authenticated');
    }
    
    // Store user ID in cookie
    document.cookie = `user_id=${user.id}; path=/; secure; samesite=lax; max-age=3600`;
    
    // Generate and store state parameter
    const state = generateState();
    document.cookie = `oauth_state=${state}; path=/; secure; samesite=lax; max-age=3600`;
    
    // Redirect to our Facebook auth endpoint
    window.location.href = '/.netlify/functions/facebook-auth';
  } catch (err) {
    console.error('Error initiating Facebook OAuth flow:', err);
    throw err;
  }
};